import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { AppDataProvider } from './context/AppDataContext';

//Styles
import './styles/main.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppDataProvider>
      <App />
    </AppDataProvider>
  </React.StrictMode>
);